import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useActiveDialog } from '../../../data/hooks/ui/useActiveDialog';
import stylesheet from './Dialog.module.scss';
import { debounce } from 'lodash';
import { createPortal } from 'react-dom';
import useAnimatedVisibility from '../AnimatedVisiblilty/useAnimatedVisibility';

const Dialog = () => {
    const dialog = useActiveDialog(),
        ref = useRef(),
        [currentDialog, setCurrentDialog] = useState(),
        {
            id,
            message,
            title,
            options = [],
            callback,
            otherProps,
        } = currentDialog || {},
        {
            className = '',
            visibleClassName = '',
            hiddenClassName = '',
        } = otherProps ?? {},
        { mounted, visible, showing, hiding } = useAnimatedVisibility({
            visible: !!dialog,
        })

    useEffect(() => {
        if (dialog) setCurrentDialog(dialog);
        else if (!dialog && currentDialog) {
            let t = setTimeout(() => setCurrentDialog(null), 300);
            return () => clearTimeout(t);
        }
    }, [dialog]);

    const focusDefault = useCallback(() => {
            ref.current?.querySelector('button')?.focus();
        }, []),
        handleBlur = useCallback(
            debounce(() => {
                let elem = document.activeElement;
                while (elem) {
                    if (elem === ref.current) break;
                    elem = elem.parentNode;
                }
                if (!elem) focusDefault();
            }, 10),
            []
        );

    useEffect(() => {
        focusDefault();
    }, [options]);

    useEffect(() => {
        try {
            document
                .querySelector('#networkapp')
                .toggleAttribute('disabled', !!dialog);
        } catch (error) {}
        try {
            document
                .querySelector('#splitScreen')
                .toggleAttribute('disabled', !!dialog);
        } catch (error) {}
    }, [dialog]);

    const handleClick = useCallback(
        (option) => {
            app.store.dispatch(app.actions.ui.dialog.hide(id));
            callback(option);
        },
        [id, callback]
    );

    if (!mounted) return null;

    return createPortal(
        <>
            <div
                ref={ref}
                className={[
                    stylesheet.Dialog,
                    visible ? stylesheet.visible : stylesheet.hidden,
                    visible ? visibleClassName : hiddenClassName,
                    className,
                ].join(' ')}
                onBlur={handleBlur}
            >
                {title ? <h3>{title}</h3> : null}
                {message}
                <div className={stylesheet.options}>
                    {options.map((option, i) => (
                        <button key={i} onClick={() => handleClick(option)}>
                            {option}
                        </button>
                    ))}
                </div>
            </div>
            <div
                className={[
                    stylesheet.overlay,
                    visible ? stylesheet.visible : stylesheet.hidden,
                ].join(' ')}
            ></div>
        </>,
        document.querySelector('#dialogs')
    );
};

export default Dialog;
